import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-mypage--top" }
const _hoisted_2 = { class: "c-eyecatch c-eyecatch--top" }
const _hoisted_3 = { class: "c-eyecatch__img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-mypage__ttl c-ttl" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("マイページ")
const _hoisted_7 = { class: "p-mypage__ttl__username" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("section", {
  class: "p-mypage__info p-mypage__sec",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "c-message" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "c-message__heading" }, [
      /*#__PURE__*/_createElementVNode("i"),
      /*#__PURE__*/_createElementVNode("span", null, "お知らせ")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "c-message__txt" }, " こちらにお知らせが表示されます。 ")
  ])
], -1)
const _hoisted_9 = {
  key: 0,
  class: "p-mypage__sec"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "c-message" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "c-message__txt c-message__txt--primary" }, [
    /*#__PURE__*/_createElementVNode("i"),
    /*#__PURE__*/_createElementVNode("span", null, "ご利用中のサービス／おすすめのサービス一覧の取得に失敗しました。ブラウザの更新をお試しください。")
  ])
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "p-mypage__service p-mypage__sec"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "p-mypage__ttl--sub c-ttl--sub" }, "ご利用中のサービス", -1)
const _hoisted_14 = { class: "p-mypage__service-list" }
const _hoisted_15 = { class: "p-mypage__service__img" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "p-mypage__service__meta" }
const _hoisted_18 = { class: "p-mypage__service__discription" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "p-mypage__service-listitem"
}
const _hoisted_21 = { class: "p-mypage__service__img" }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "p-mypage__service__meta" }
const _hoisted_24 = { class: "p-mypage__service__discription" }
const _hoisted_25 = {
  key: 0,
  class: "p-mypage__service__apl"
}
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/ja-jp?size=250x83&releaseDate=1636761600&h=91ddad22a6f5d67273b1fbe3fe6d05d2",
  alt: "Download on the App Store",
  style: {"border-radius":"13px"}
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Google Play で手に入れよう",
  src: "https://play.google.com/intl/en_us/badges/static/images/badges/ja_badge_web_generic.png"
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 2,
  class: "p-mypage__service p-mypage__sec"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", { class: "p-mypage__ttl--sub c-ttl--sub" }, "おすすめのサービス", -1)
const _hoisted_35 = { class: "p-mypage__service-list" }
const _hoisted_36 = {
  key: 0,
  class: "p-mypage__service-listitem"
}
const _hoisted_37 = { class: "p-mypage__service__img" }
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { class: "p-mypage__service__meta" }
const _hoisted_40 = { class: "p-mypage__service__discription" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "p-mypage__service-listitem"
}
const _hoisted_43 = { class: "p-mypage__service__img" }
const _hoisted_44 = ["src", "alt"]
const _hoisted_45 = { class: "p-mypage__service__meta" }
const _hoisted_46 = { class: "p-mypage__service__discription" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 1,
  class: "p-mypage__service__apl"
}
const _hoisted_49 = ["href"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/ja-jp?size=250x83&releaseDate=1636761600&h=91ddad22a6f5d67273b1fbe3fe6d05d2",
  alt: "Download on the App Store",
  style: {"border-radius":"13px"}
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["href"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Google Play で手に入れよう",
  src: "https://play.google.com/intl/en_us/badges/static/images/badges/ja_badge_web_generic.png"
}, null, -1)
const _hoisted_54 = [
  _hoisted_53
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.store.state.userInfo.commonAttrInfo.imagePath ? _ctx.store.state.userInfo.commonAttrInfo.imagePath : require('@/assets/images/common/img_user-default.svg'),
          alt: "User Profile Image"
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("h2", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.nickName ? _ctx.nickName : 'User Name'), 1)
    ]),
    _hoisted_8,
    (_ctx.registeredSiteList.length === 0 && _ctx.notRegisteredSiteList.length === 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_9, _hoisted_11))
      : _createCommentVNode("", true),
    (_ctx.registeredSiteList.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registeredSiteList, (registeredSite) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: registeredSite.link_id!
              }, [
                (!!registeredSite.children)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(registeredSite.children, (subSite) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: subSite.linkage_sub_id!,
                        class: "p-mypage__service-listitem"
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("img", {
                            src: `${_ctx.logoImageBaseURL}logo_${registeredSite.link_id}_${subSite.linkage_sub_id}.svg`,
                            alt: subSite.name + '(' + subSite.name_jp + ')'
                          }, null, 8, _hoisted_16)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("p", _hoisted_18, _toDisplayString(subSite.description), 1),
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.moveToWithdrawal(registeredSite, subSite)),
                            class: "p-mypage__service__link c-link"
                          }, "サービス連携を解除する", 8, _hoisted_19)
                        ])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("li", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          src: _ctx.logoImageBaseURL + 'logo_' + registeredSite.link_id + '.svg',
                          alt: registeredSite.name + '(' + registeredSite.name_jp + ')'
                        }, null, 8, _hoisted_22)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("p", _hoisted_24, _toDisplayString(registeredSite.description), 1),
                        (registeredSite.kind === 'apl')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (!registeredSite.is_close)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createElementVNode("a", {
                                      class: "p-mypage__service__apl--ios",
                                      href: (registeredSite.withdrawal_url as any).ios,
                                      target: "_blank",
                                      style: {"display":"inline-block","overflow":"hidden","border-radius":"13px"}
                                    }, _hoisted_28, 8, _hoisted_26),
                                    _createElementVNode("a", {
                                      class: "p-mypage__service__apl--android",
                                      href: (registeredSite.withdrawal_url as any).android,
                                      target: "_blank"
                                    }, _hoisted_31, 8, _hoisted_29)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.moveToWithdrawal(registeredSite)),
                              class: "p-mypage__service__link c-link"
                            }, "サービス連携を解除する", 8, _hoisted_32))
                      ])
                    ]))
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.notRegisteredSiteList.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("ul", _hoisted_35, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notRegisteredSiteList, (notRegisteredSite) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: notRegisteredSite.link_id!
              }, [
                (!!notRegisteredSite.children)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(notRegisteredSite.children, (subSite) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: subSite.linkage_sub_id!
                      }, [
                        (!subSite.is_close)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("img", {
                                  src: `${_ctx.logoImageBaseURL}logo_${notRegisteredSite.link_id}_${subSite.linkage_sub_id}.svg`,
                                  alt: subSite.name + '(' + subSite.name_jp + ')'
                                }, null, 8, _hoisted_38)
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("p", _hoisted_40, _toDisplayString(subSite.description), 1),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.moveToRegister(notRegisteredSite, subSite)),
                                  class: "p-mypage__service__link c-link c-link--primary"
                                }, "サービスを連携する", 8, _hoisted_41)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!notRegisteredSite.is_close)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("img", {
                                src: _ctx.logoImageBaseURL + 'logo_' + notRegisteredSite.link_id + '.svg',
                                alt: notRegisteredSite.name + '(' + notRegisteredSite.name_jp + ')'
                              }, null, 8, _hoisted_44)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("p", _hoisted_46, _toDisplayString(notRegisteredSite.description), 1),
                              (notRegisteredSite.kind === 'web')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.moveToRegister(notRegisteredSite)),
                                    class: "p-mypage__service__link c-link c-link--primary"
                                  }, "サービスを連携する", 8, _hoisted_47))
                                : (notRegisteredSite.kind === 'apl')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                      _createElementVNode("a", {
                                        class: "p-mypage__service__apl--ios",
                                        href: (notRegisteredSite.login_url as any).ios,
                                        target: "_blank",
                                        style: {"display":"inline-block","overflow":"hidden","border-radius":"13px"}
                                      }, _hoisted_51, 8, _hoisted_49),
                                      _createElementVNode("a", {
                                        class: "p-mypage__service__apl--android",
                                        href: (notRegisteredSite.login_url as any).android,
                                        target: "_blank"
                                      }, _hoisted_54, 8, _hoisted_52)
                                    ]))
                                  : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}